var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import ProductCard from '../ProductCard';
function chunks(array, size) {
    return Array.from(new Array(Math.ceil(array.length / size)), function (_, i) {
        return array.slice(i * size, i * size + size);
    });
}
function ProductListing(_a) {
    var content = _a.content, pageName = _a.pageName;
    var title = content.title, productCardData = content.productCardData;
    var rows = chunks(productCardData, 3);
    return (_jsxs(FlexSection, __assign({ backgroundColorStyle: "bg-surface-white", paddingStyle: "!flex-col px-2xs-gutter py-md-gutter md:px-2xl-gutter md:py-xl-gutter gap-xl-m md:gap-4xl-m" }, { children: [_jsx(Heading, __assign({ size: "md", className: "md:text-center" }, { children: title })), _jsx("div", __assign({ className: "flex flex-col items-center gap-4xl-m" }, { children: rows.map(function (row, i) { return (_jsx("div", __assign({ className: "flex flex-col md:flex-row md:justify-around gap-4xl-m w-full md:w-auto" }, { children: row.map(function (productCard) {
                        var _a;
                        return (_jsx(ProductCard, { isNew: productCard.isNew, productDetails: productCard.productDetails, imageData: productCard.imageData, backgroundColorStyle: "bg-surface-beige", pageName: pageName }, (_a = productCard.productDetails) === null || _a === void 0 ? void 0 : _a.productName));
                    }) }), "row-".concat(i))); }) }))] })));
}
export default ProductListing;
